export default {
  chatbot: {
    toggle_label: "Ouvrir l'assistante Léa",
    close_label: "Fermer l'assistante Léa",
    panel_label: "Assistante Léa",
    send_label: "Envoyer le message",
    stop_label: "Arrêter la génération",
    loading_label: "Léa est en train d'écrire…",
  },
};
